import { forwardRef } from '@chakra-ui/react';
import IconButton, { IconButtonProps } from '../IconButton/IconButton';

export interface ControlButtonProps extends Omit<IconButtonProps, 'iconSize' | 'size' | 'variant'> {
  size?: 'xs' | 'sm' | 'md' | 'lg';
}

const COLORS = {
  color: 'button/secondary/fg',
  _hover: {
    backgroundColor: 'button/tertiary/bg-hover',
    color: 'button/secondary/fg-hover',
  },
  _active: {
    backgroundColor: 'button/tertiary/bg-active',
    color: 'button/secondary/fg-active',
  },
  _disabled: {
    backgroundColor: 'button/tertiary/bg-disabled',
    color: 'button/tertiary/fg-disabled',
    cursor: 'not-allowed',
  },
};

const ControlButton = forwardRef<ControlButtonProps, 'button'>((props, ref) => {
  const { isDanger, size = 'sm', ...rest } = props;

  const colors = Object.assign(!isDanger ? COLORS : {});

  return (
    <IconButton
      iconSize={size === 'xs' ? '16' : '24'}
      isDanger={isDanger}
      ref={ref}
      size={size === 'xs' ? 'sm' : size}
      variant="tertiary"
      {...colors}
      {...rest}
    />
  );
});

export default ControlButton;
